<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24"
       viewBox="0 0 24 24">
    <defs>
      <rect id="rect-1" width="24" height="24" x="0" y="0"/>
      <mask id="mask-2" maskContentUnits="userSpaceOnUse" maskUnits="userSpaceOnUse">
        <rect width="24" height="24" x="0" y="0" fill="black"/>
        <use fill="white" xlink:href="#rect-1"/>
      </mask>
    </defs>
    <g transform="rotate(90.000032 12 12)">
      <use fill="none" xlink:href="#rect-1"/>
      <g mask="url(#mask-2)">
        <path fill-rule="evenodd" d="M6 6.17993164V3c0-.5522461-.4477539-1-1-1-.55230713
        0-1 .4477539-1 1v3.17993164C2.8135376 6.6105957 2.02349854 7.73779297 2.02349854 9c0 1.26220703.79003906
        2.3894043 1.97650146 2.82006836V21c0 .5522461.44769287 1 1 1 .5522461 0 1-.4477539 1-1v-9.17993164C7.18640137
        11.3894043 7.97644043 10.26220703 7.97644043 9c0-1.26220703-.79003906-2.3894043-1.97644043-2.82006836zm7
        8V3c0-.5522461-.4477539-1-1-1-.55230713 0-1 .4477539-1 1v11.17993164C9.8135376 14.6105957 9.02349854
        15.73779297 9.02349854 17c0 1.26220703.79003906 2.3894043 1.97650146 2.82006836V21c0 .5522461.44769287
        1 1 1 .5522461 0 1-.4477539 1-1v-1.17993164C14.18640137 19.3894043 14.97644043 18.26220703 14.97644043
        17c0-1.26220703-.79003906-2.3894043-1.97644043-2.82006836zM20 3v5.17993164C21.18640137 8.6105957 21.97644043
        9.73779297 21.97644043 11c0 1.26220703-.79003906 2.3894043-1.97644043 2.82006836V21c0 .5522461-.4477539
        1-1 1-.55230713 0-1-.4477539-1-1v-7.17993164C16.8135376 13.3894043 16.02349854 12.26220703 16.02349854
        11c0-1.26220703.79003906-2.3894043 1.97650146-2.82006836V3c0-.5522461.44769287-1 1-1 .5522461 0 1 .4477539
        1 1zM4 9c0 .5522461.44769287 1 1 1s1-.4477539 1-1c0-.5522461-.44769287-1-1-1s-1 .4477539-1 1zm14
        2c0 .5522461.44769287 1 1 1s1-.4477539 1-1c0-.5522461-.44769287-1-1-1s-1 .4477539-1 1zm-7
        6c0 .5522461.44769287 1 1 1s1-.4477539 1-1c0-.5522461-.44769287-1-1-1s-1 .4477539-1 1z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconFilter',
};
</script>

<style scoped>

</style>
